<template>
  <transition name="rich-picker-fade">
    <popup
      v-show="isVisible"
      class="rich-formily-popup"
      :type="type"
      :visible="visible"
      :mask="mask"
      :center="center"
      :z-index="zIndex"
      :position="position"
      @touchmove.prevent
      @mask-click="maskClick"
    >
      <transition name="rich-picker-move" @after-leave="afterLeave">
        <div
          v-show="isVisible"
          :class="['rich-picker-panel', !raduis && 'not-raduis']"
          :style="_ratio"
          @click.stop
        >
          <div :class="['rich-picker-choose', hideTilte && 'hide-title']">
            <span
              v-if="cancelIcon"
              :class="['rich-picker-cancel', cancelIcon]"
              @click="cancel(2)"
            ></span>
            <div class="rich-picker-title-group">
              <slot v-if="$slots && $slots.title" name="title"></slot>
              <template v-else>
                <h1 class="rich-picker-title" v-html="title"></h1>
                <h2 v-if="subtitle" class="rich-picker-subtitle" v-html="subtitle"></h2>
              </template>
            </div>
          </div>

          <div class="formily-picker-content">
            <div
              v-if="_isHideDestroy"
              class="rich-content-inner"
              @touchmove="e => e.stopPropagation()"
            >
              <slot />
            </div>
          </div>
          <div v-if="cancelTxt || confirmTxt" class="rich-picker-footer">
            <rich-button
              v-if="cancelTxt"
              :class="[confirmTxt && 'rich-picker-btn', 'picker-cancel-btn']"
              :dark="true"
              :outline="true"
              :disabled="cancelDisabled"
              @click="cancel(3)"
              >{{ _cancelTxt }}</rich-button
            >
            <rich-button
              v-if="confirmTxt"
              :class="cancelTxt && 'rich-picker-btn'"
              :primary="true"
              :disabled="confirmDisabled"
              @click="confirm"
              >{{ _confirmTxt }}</rich-button
            >
          </div>
        </div>
      </transition>
    </popup>
  </transition>
</template>
<script>
import { Popup } from '@didi/rich-ui'
import './style.scss'
const EVENT_TOGGLE = 'toggle'
let zIndex = 101
export default {
  components: { Popup },
  model: {
    prop: 'visible',
    event: EVENT_TOGGLE,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: Boolean,
      default: true,
    },
    center: {
      // 写死了吧
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: '',
    },
    zIndex: {
      type: Number,
      default: zIndex,
    },
    maskClosable: {
      type: Boolean,
      default: true,
    },
    // picker icon
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: String,
    },
    // eslint-disable-next-line vue/require-default-prop
    subtitle: {
      type: String,
    },
    cancelIcon: {
      type: String,
      default: 'fusion-r_fusion_icon_closed',
    },
    // eslint-disable-next-line vue/require-default-prop
    cancelTxt: {
      type: String,
    },
    // eslint-disable-next-line vue/require-prop-types
    cancelDisabled: {
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    confirmTxt: {
      type: String,
    },
    // eslint-disable-next-line vue/require-prop-types
    confirmDisabled: {
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    raduis: {
      default: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    hideDestroy: {
      default: false,
    },
    // 占屏幕比例
    // eslint-disable-next-line vue/require-prop-types
    ratio: {
      default: 0,
    },
    // eslint-disable-next-line vue/require-prop-types
    hideTilte: {
      default: false,
    },
  },
  data() {
    return {
      // If use the prop visible directly, the toggle will failed when user haven't set v-model as a reactive property.
      // So we use the data isVisible instead.
      isVisible: false,
    }
  },
  computed: {
    _zIndex() {
      return zIndex
    },
    _cancelTxt() {
      // TODO: 先用这里的翻译
      return this.cancelTxt || this.gettext('取消')
    },
    _confirmTxt() {
      // TODO: 先用这里的翻译
      return this.confirmTxt || this.$t('Gattaran_form_zKmF_tGJc' /** 确认 */)
    },
    _ratio() {
      if (!this.ratio) return {}
      const placements = {
        left: 'width',
        right: 'width',
        top: 'height',
        bottom: 'height',
      }
      const attr = placements[this.position || 'bottom']
      return { [attr]: this.ratio + '%' }
    },
    _isHideDestroy() {
      if (this.hideDestroy) {
        return this.isVisible
      } else {
        return true
      }
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.$emit(EVENT_TOGGLE, newVal)
      }
    },
    visible: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.show()
        } else if (oldVal && !this._createAPI_reuse) {
          this.hide()
        }
      },
    },
  },
  mounted() {
    if (this.appendToBody) {
      zIndex += 1
      document && document.body && document.body.append(this.$el)
    }
  },
  destroyed() {
    if (this.appendToBody) {
      document &&
        document.body &&
        document.body.contains(this.$el) &&
        document.body.removeChild(this.$el)
    }
  },
  methods: {
    show() {
      zIndex += 1
      this.isVisible = true
    },
    hide() {
      this.isVisible = false
    },
    maskClick() {
      if (this.maskClosable) {
        this.cancel(1)
      }
    },
    cancel(type) {
      if (this.$listeners && 'cancel' in this.$listeners) {
        const result = this.$listeners.cancel(() => {
          this.hide()
        }, type)
        result && this.hide()
      } else {
        this.hide()
        // 1 点击弹层关闭弹窗 2.点击X关闭， 3.点击取消关闭
        this.$emit('cancel', undefined, type)
      }
    },
    confirm() {
      if (this.$listeners && 'confirm' in this.$listeners) {
        const result = this.$listeners.confirm(() => {
          this.hide()
        })
        result && this.hide()
      } else {
        this.hide()
        this.$emit('confirm')
      }
    },
    afterLeave() {
      if (!this.isVisible) {
        this.$emit(EVENT_TOGGLE, this.isVisible)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.hide-title {
  display: none;
}
</style>
